export function hasRuntimeSettingsAccess(role: string | null | undefined): boolean {
  return role?.toLowerCase() === 'admin';
}
